function loading() {
  document.documentElement.classList.remove('is-loading');
}

export {loading};
